import React from "react";
import { Draggable } from "react-beautiful-dnd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGripVertical } from "@fortawesome/free-solid-svg-icons";
import { faTimesCircle } from "@fortawesome/free-regular-svg-icons";
import { Intervention } from "../../../../../../store/onboarding/cases/types";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

type Props = {
  intervention: Intervention;
  index: number;
  isLoading?: boolean;
  interventionCount?: number;
  isDragPermitted?: boolean;
  isFinished?: boolean;
  onRemove?: (intervention: Intervention) => void;
};

const InterventionRow = ({
  intervention,
  index,
  isLoading,
  onRemove,
  interventionCount,
  isDragPermitted,
  isFinished
}: Props) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: intervention.id.toString(),
    disabled: isLoading,
  });

  // Extract only translate, remove any scale transforms
  const transformStyle = transform ? {
    x: transform.x,
    y: transform.y,
    scaleX: 1, // Force scale to 1 to prevent size changes
    scaleY: 1,
  } : null;

  const isDragEnabled = interventionCount && (interventionCount > 1) && (isFinished ? isDragPermitted : true)
  const style: React.CSSProperties = {
    transform: transformStyle ? `translate3d(${transformStyle.x}px, ${transformStyle.y}px, 0) scale(1)` : undefined,
    transition,
    // Remove opacity change to prevent fading
    // Prevent any scaling or font size changes during drag
    fontSize: 'inherit',
    lineHeight: 'inherit',
    cursor: (isDragEnabled ? !isLoading : false) ? (isDragging ? 'grabbing' : 'grab') : 'default',
  };
  return (
    <div
      ref={setNodeRef}
      style={style}
      className="d-flex align-items-center justify-content-between"
      {...attributes}
      {...(isDragEnabled ? listeners : {})}
    >
      <h4 className="sequence-list-row-wrapper">
        {isDragEnabled ? (
          <FontAwesomeIcon icon={faGripVertical} />
        ) : null}

        <span>{index + 1}.</span>

        <span>{intervention.name}</span>
      </h4>
      {/* <div className="m-1" onClick={() => onRemove && onRemove(intervention)}>
        <FontAwesomeIcon icon={faTimesCircle} size="lg" className="pointer" />
      </div> */}
    </div>
)
};

export default InterventionRow;
